<template>

  <b-row>
     <b-col>
      <b-row>
          <b-col md="3" class="mb-3">
            <b-form-group horizontal label="Search" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search..." />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''" title="Clear"> <i class="fa fa-times"></i></b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!-- <b-col md="3" class="mb-3">
            <b-form-group horizontal label="Sort" class="mb-0">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-form-select :disabled="!sortBy" v-model="sortDesc" slot="append">
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col> -->
      </b-row>    
      
      <!--  <b-col md="3" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
      </b-col> -->
      <b-table id="table-notification" hover="hover" small="small" striped="striped" bordered="bordered" responsive="sm" 
          ref="table"
          :items="myProvider" 
          :fields="fields" 
          :current-page="currentPage" 
          :per-page="perPage"
          @filtered="onFiltered" 
          :filter="filter"
          sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :busy.sync="isBusy"
          :no-provider-paging="noProviderPaging"
          :no-provider-filtering="noProviderFiltering"
          :no-provider-sorting="noProviderSorting">

        <template slot="request_date" slot-scope="data">
          {{data.item.request_date | formatDate('DD/MM/YYYY HH:mm:ss')}} 
        </template>
        <template slot="last_update" slot-scope="data">
          {{data.item.last_update | formatDate('DD/MM/YYYY HH:mm:ss')}} 
        </template>
        <template slot="start_date" slot-scope="data">
          {{data.item.start_date | formatDate('DD/MM/YYYY HH:mm:ss')}} 
        </template>
        <template slot="centcom_consent" slot-scope="data">
          {{data.item.notification_recipient == "EHOC" ? "NA": data.item.centcom_consent }} 
        </template>
        <template slot="org_anonymous" slot-scope="data">
          {{data.item.notification_recipient == "EHOC" ? "NA": data.item.org_anonymous }} 
        </template>          
        <template slot="emergency_type" slot-scope="data" v-if="data.item.emergency_type.length > 0">
          {{data.item.emergency_type}}:{{data.item.emergency_description}} 
        </template>         
        <template slot="status" slot-scope="data">
          <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>          
        </template>
        <template slot="action" slot-scope="data" style="width:20px">
                <b-dropdown class="float-right" variant="transparent text-muted p-0" right no-caret>
                  <template slot="button-content">
                    <i class="icon-settings"></i>
                  </template> 

                  <b-dropdown-item @click="viewEventHandler(data.item.id, data.item.request_type_id)">Edit Form</b-dropdown-item>
                  <!-- <b-dropdown-item v-if="data.item.request_type_id !== 1" @click="mofaEventHandler(data.item)">MoFA</b-dropdown-item> -->
                  <b-dropdown-item @click="itemEventHandler(data.item)" v-b-modal.sendEmailModal v-b-modal.modal-center>Notify User</b-dropdown-item>
                  <b-dropdown-item @click="itemEventHandler(data.item)" v-b-modal.changeStatusModal v-b-modal.modal-center>Change Status</b-dropdown-item>
                  <!-- <b-dropdown-item @click="itemEventHandler(data.item)" v-b-modal.confirmCopyModal v-b-modal.modal-center :disabled="validateCopyStatusId(data.item)">Copy</b-dropdown-item> -->
                  <b-dropdown-item @click="downloadEventHandler(data.item.id, data.item.request_type_id)">Download</b-dropdown-item>
                </b-dropdown> 
        </template>
      </b-table>
      <nav>
      <!-- <b-pagination size="sm" :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next"/> -->
      <b-pagination aria-controls="table-notification" size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" prev-text="Prev" next-text="Next"/>      
    </nav>  
    </b-col>

    <!--// MODAL Change Status -->   
     <b-modal centered ref="changeStatusModal" :title="getChangeStatusTitle" size="lg" class="modal-primary" id="changeStatusModal" @ok="submitStatusEventHandler">
      <b-row>
        <b-col sm="12">
          <b-form>
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="city">Agency</label>
                    <b-form-input type="text" id="city" v-model="selectedItem.agency_desc" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                      <label for="city">Purpose of Mission</label>
                      <b-form-input type="text" id="purposeMission" :value="selectedItem.purpose_desc" disabled></b-form-input>
                  </b-form-group>
                </b-col>                          
              </b-row>             
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="postal-code">Requested Date</label>
                    <b-form-input type="text" id="requestedDate" :value="selectedItem.request_date | formatDate('DD/MM/YYYY')" disabled></b-form-input>
                  </b-form-group>
                </b-col>      
                <b-col sm="4">                  
                  <b-form-group>
                    <label for="ehoc-ref">Generate NV# for</label> 
                    <b-input-group>
                      <b-form-select :value="selectedNV" :options="nvOptions" text-field="text" value-field="value" @change="selectNVChangeEventHandler">
                      <template slot="first">
                          <option :value="null" disabled>-- Please select an option --</option>
                      </template>  
                      </b-form-select>
                      <b-input-group-append>
                         <b-button variant="secondary" @click="nextNVEventHandler" title="Generate NV#" ><i class="fa fa-magic"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>   
                <b-col sm="4"> 
                  <b-form-group>
                    <label for="country">NV#</label>
                    <b-input-group>
                      <b-form-input type="text" v-model="nvNumber" id="nvNumber"></b-form-input>
                    </b-input-group>  
                  </b-form-group>
                </b-col>                
              </b-row>
              <b-row>
               <b-col sm="6"> 
                  <b-form-group>
                    <label for="country">Status</label>                      
                    <b-form-select :value="selectedStatusId" @change="statusChangeEventHandler">
                        <option :value="null" disabled>-- Please select an option --</option>                        
                        <!-- <option v-for="item in statusList" :value="item.id" v-if="item.id !== 2 && item.id !== 13"> -->
                        <!-- <option v-for="item in statusList" :value="item.id" 
                              v-if="item.id !== 2 && item.id !== 13 && item.id !== 5 && item.id !== 6 && item.id !== 7 && 
                              item.id !== 12 && item.id !== 15 && item.id !== 17 && item.id !== 18">
                          {{item.name}}
                        </option>  -->
                        <option v-for="item in statusList" :value="item.id" 
                              v-if="item.id === 1 || item.id === 2 || item.id === 3 || item.id === 6 || item.id === 8 ||
                              item.id === 9 || item.id === 10 || item.id === 14 || item.id === 11 || item.id === 16  ||
                              item.id === 17 || item.id === 12 || item.id === 18 || item.id === 19 ||
                              item.id === 21 || item.id === 22">
                          {{item.name}}
                        </option> 
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="4">                    
                  <b-form-group>
                    <label for="country">Date Submitted</label>                      
                    <datepicker format="DD/MM/YYYY HH:mm:ss" v-model="submitted_ehoc" :local="local" :disabled-date="disabledDate"/>
                  </b-form-group>               
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <label for="ehoc-ref">EHOC Ref#</label>
                    <b-form-input type="text" v-model="ehoc_ref" placeholder=""></b-form-input>
                  </b-form-group>
                </b-col>                              
              </b-row>
              <b-row>
                <b-col sm="3">
                  <b-form-group>
                    <label for="ehoc-ref">CENTCOM NV#</label>
                    <b-input-group>
                      <b-form-input type="text" v-model="centcom_ref" placeholder=""></b-form-input>
                      <b-input-group-append>
                          <b-button variant="secondary" @click="nextCentcomNVEventHandler" title="Generate NV#" ><i class="fa fa-magic"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>        
             </b-row>
              <b-row>
                <b-col sm="8">   
                  <b-form-group>
                      <label for="country">Notes</label>
                      <b-form-textarea id="notes"
                        v-model="notes"
                         placeholder=""
                         :rows="3"
                         :max-rows="6">
                      </b-form-textarea>
                  </b-form-group>
                </b-col>                
             </b-row>


              <!-- <b-row> -->
                
                <!-- <b-col sm="6">
                  <b-form-group>
                    <label for="ehoc-ref">EHOC Status</label>
                    <b-form-select :value="selectedEHOCStatusId" @change="ehocStatusChangeEventHandler">
                        <option :value="null" disabled>-- Please select an option --</option>
                        <option v-for="item in statusList" :value="item.id" 
                        v-if="item.id === 3 || item.id === 5 || item.id === 6 || item.id === 7 || item.id === 9 ||
                              item.id === 12 || item.id === 15 || item.id === 17 || item.id === 18">
                        {{item.name}}
                        </option> 
                    </b-form-select>
                  </b-form-group>
                </b-col>                    -->
              <!-- </b-row> -->

              <div v-if="selectedStatusId === 3 || selectedStatusId === 9">
               <b-row>
                <b-col sm="12"> 
                    <b-alert :show="showUploadAlert"
                             dismissible
                             variant="warning">
                        <strong>Upload completed!</strong> You successfully upload the file.
                    </b-alert>
                    <b-alert :show="showUploadError"
                           dismissible
                           variant="danger">
                        <strong>Upload Error!</strong> File size must not exceed 1MB in size.
                    </b-alert>
                    <b-form-group>
                       <file-upload
                            ref='fileUpload'
                            title="Please upload a PDF version of the letter in English and Arabic to submit to EHOC."
                            accept=".xlsx, .xls, .pdf"
                            @event-handler="fileUploadEventHandler($event)">            
                          </file-upload> 
                    </b-form-group>
                </b-col>
                
                <!-- <b-col sm="5"> 
                    <b-form-group>
                      <label>Upload the following documents:</label>
                       <ul>
                        <li>Pax Manifest</li>
                        <li>Passport copies and Visa copies</li>
                        <li>Cargo documents</li>
                        <li>Packing lists</li>
                        <li>Any other documents</li>                      
                       </ul>
                    </b-form-group>
                </b-col> -->
              </b-row>

              <b-row>
                <b-col>
                    <b-table id="table-attachment" style="background-color: #fff" hover="hover" small="small" striped="striped" bordered="bordered" responsive="sm" :items="attachments" :fields="uploadFields" :current-page="currentPageAttachment" :per-page="perPageAttachment">
                       <template slot="date_uploaded" slot-scope="data">
                        {{data.item.date_uploaded | formatDate('DD/MM/YYYY HH:mm:ss')}} 
                      </template>
                      <template slot="action" slot-scope="data" style="width:10px">
                          <b-dropdown class="float-right" variant="transparent text-muted p-0" right no-caret>
                            <template slot="button-content">
                              <i class="icon-settings"></i>
                            </template>
                            <b-dropdown-item @click="uploadItemEventHandler(data.item)"> Delete</b-dropdown-item>
                            <b-dropdown-item @click="downloadAttachmentEventHandler(data.item)"> Download</b-dropdown-item>                            
                          </b-dropdown>                
                      </template>
                    </b-table>
                </b-col>
              </b-row>
              <b-row> 
                <b-col>
                  <nav> 
                    <b-pagination aria-controls="table-attachment" size="sm" :total-rows="getRowCount(attachments)" :per-page="perPageAttachment" v-model="currentPageAttachment" prev-text="Prev" next-text="Next"/>
                  </nav> 
                </b-col> 
              </b-row>
             </div> 

          </b-form>        
        </b-col>
      </b-row>
    </b-modal>  
    <!--// MODAL Change Status -->  

    <!--// MODAL Send Email Notification-->   
     <b-modal centered ref="sendEmailModal" title="Notify Requester" class="modal-primary" id="sendEmailModal" @ok="sendEmailEventHandler" ok-title="Send">
      <b-row>
        <b-col sm="12">
          <b-form>
              <b-row>
                <b-col sm="8">
                  <b-form-group>
                    <label>To</label>
                    <b-form-input type="text" id="city" v-model="selectedItem.requested_by_email" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="postal-code">Date</label>
                    <b-form-input type="text" id="currentDate" :value="this.currentDate | formatDate('DD/MM/YYYY')" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group>
                    <label for="city">Subject</label>
                    <b-form-input type="text" id="emailSubject" v-model="emailSubject"></b-form-input>
              </b-form-group>             
              <b-form-group>
                  <label>Message</label>
                  <b-form-textarea id="emailMessage"
                    v-model="emailMessage"
                     placeholder=""
                     :rows="5"
                     :max-rows="10">
                  </b-form-textarea>
              </b-form-group>
              <!-- <b-form-group>
                  <label>Attachments</label>
                  <file-upload
                          ref='fileUpload'
                          title='Please enter description of the file into the description field and click "Browse" to select file from your local computer.  When ready, click "Start Upload" to start uploading the file.'
                          accept=".png, .jpg, .jpeg"
                          @event-handler="fileUploadEventHandler($event)">            
                    </file-upload>
              </b-form-group>               -->
          </b-form>        
        </b-col>
      </b-row>
    </b-modal>  
    <!--// MODAL Change Status -->  

    <!--// MODAL Confirm Remove Attachment -->   
    <b-modal title="Confirm" class="modal-primary" id="confirmAttachmentModal" @ok="removeAttachmentEventHandler" ok-title="Yes" cancel-title="No" centered>
        <p class="my-4">Are you sure you want to remove this attachment?</p>     
    </b-modal>  
    <!--// MODAL Confirm Remove Attachment -->  

    <!--// MODAL Confirm Copy Notification -->   
    <b-modal title="Confirm" class="modal-primary" id="confirmCopyModal" @ok="copyEventHandler()" ok-title="Yes" cancel-title="No" centered>
        <p class="my-4">Are you sure you want to create a copy of this notification?</p>
    </b-modal>  
    <!--// MODAL Confirm Copy Notification -->   

  </b-row> 

</template>

<script>
import * as utils from '@/mixins/utils'
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import { mapGetters } from 'vuex'
import NotificationService from '@/api/NotificationService'
import LandMovementService from '@/api/LandMovementService'
import TempVenueService from '@/api/TempVenueService'
import SeaService from '@/api/SeaService'
import AirService from '@/api/AirService'
import NSLService from '@/api/NSLService'
import CommonService from '@/api/CommonService'
import FileUpload from '@/components/file-upload/FileUpload'
import UploadService from '@/api/UploadService'
import toast from '@/mixins/toast'
import Api from '@/api/Api'

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export default {

  components: {
    FileUpload
  },

  data: () => {
    return {      
      nvOptions: [
        { value: 1, text: 'UN' },
        { value: 2, text: 'I/NGOs'}
      ],
      fields: [
        {label: 'Notification #', key: 'id', sortable: true},
        {label: 'Notification Type', key: 'request_type_desc', sortable: true},
        {label: 'Notified By', key: 'requested_by_desc', sortable: true},
        {label: 'Notification Date', key: 'request_date', sortable: true},        
        {label: 'Start Date', key: 'start_date', sortable: true},        
        {label: 'Agency', key: 'agency_desc', sortable: true},
        {label: 'Purpose', key: 'purpose_desc', sortable: true},        
        {label: 'Notes', key: 'notes'},
        {label:'Emergency', key: 'emergency_type'},
        // {label: 'EHOC Ref#', key: 'ehoc_ref', sortable: true},
        {label: 'EHOC NV#', key: 'nv_number', sortable: true},
        {label: 'Last Update', key: 'last_update', sortable: true},
        // {label: 'Last Updated By', key: 'last_updated_by_desc', sortable: true},
        {label: 'Notification Recipient', key: 'notification_recipient', sortable: true},
        {label: 'CENTCOM Consent', key: 'centcom_consent', sortable: true},
        {label: 'CENTCOM NV#', key: 'centcom_ref', sortable: true},
        {label: 'Org Anonymous', key: 'org_anonymous', sortable: true},
        {label: 'Status', key: 'status_desc', sortable: true},
        {label: 'Action', key: 'action'}
      ],
      uploadFields: [
        {label:'Id', key: 'id', sortable: true, class: 'sm="4"'},
        {label:'Upload Date', key: 'date_uploaded', sortable: true},
        {label:'Description', key: 'description', sortable: true},
        {label:'Filename', key: 'filename', sortable: true},        
        {key: 'action'}
      ],      
      nvNumber: 0,
      selectedNV: null,
      currentDate: new Date(),
      emailTo: null,
      emailSubject: null,
      emailMessage: null,
      // currentPage: 1,
      // perPage: 10,
      // totalRows: 0,
      statusModal: false,
      notes: null,
      ehoc_ref: null,
      centcom_ref: null,
      selectedItem: {agency_id: 0, agency_desc: '', request_date: '', purpose_desc: '', status_id: 0, ehoc_ref: '', centcom_ref: '', notes: ''},
      selectedStatusId: 0,
      selectedEHOCStatusId: 0,
      submitted_ehoc: null,
      ehoc_status_id: null,

      currentPage: 1,
      perPage: 100,
      message: null,
      pageOptions: [ 5, 10, 15 ],
      sortBy: 'id',
      sortDesc: true,
      sortDirection: 'asc',
      filter: null,
      isBusy: false,
      noProviderPaging: false,
      noProviderFiltering: false,
      noProviderSorting: false,
      totalRows: 0,
      showUploadAlert: false,
      showUploadError: false,
      isUploadReady: false,
      currentPageAttachment: 1,
      perPageAttachment: 5,
      local: constants.DATE_LOCALE_EN
    }
  },
  computed: {
    ...mapGetters({
        items : types.GET_NOTIFICATION_LIST,
        agencyId: types.GET_USER_AGENCY_ID,
        statusList: types.GET_STATUSES,
        requestTypeId: types.GET_REQUEST_TYPE_ID,
        attachments: types.GET_ATTACHMENTS
    }),

    getChangeStatusTitle: function () {
      return "Notification Status #"+ this.selectedItem.id +" "+ this.selectedItem.notification_recipient
    },

    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    }   
  },

  created() {
       // this.$store.dispatch(types.ACTION_TOTAL_ROWS)    
       // console.log("** page: "+ this.currentPage)         
  },

  methods: {

    downloadAttachmentEventHandler(item) {
        CommonService.download(item).then( (resp) => {          
          
      })
    },

    validateCopyStatusId(obj) {
      if (obj.status_id === 13 || obj.status_id === 8 || obj.status_id === 18) {
          return true
      }
      else {
          return false
      }
    },

    uploadItemEventHandler(item) {          
        this.selectedAttachment = item
        this.removeAttachmentEventHandler()
    },

    removeAttachmentEventHandler() {
      let item = this.selectedAttachment;
      let $this = this
      const payload = {
            id : item.id,
            notification_id: item.notification_id
        }

        UploadService.remove(payload).then( (response) => {

          if (response) {
              CommonService.fetchDLTAttachment(payload.notification_id).then( (resp) => {
                $this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
              })
          }
 
        })        
    },

    disabledDate (time) {
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return time < yesterday
    },

    ehocStatusChangeEventHandler(e) {
      this.selectedEHOCStatusId = e
      let statusObj = this.$_.find(this.$store.state.statusList, {id: this.selectedEHOCStatusId});
      this.notes = this.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss') + '\n' + statusObj.name
    },

    myProvider (ctx) {
      let _self = this
      ctx.searchField = this.sortBy
      let offset = ctx.perPage * (ctx.currentPage-1)
      let agencyId = this.$store.state.agencyId

      let promise = Api().get('/notifications?keyword='+ (ctx.filter ? ctx.filter : '') +
                              '&field='+ ctx.searchField +
                              '&sortby='+  (ctx.sortBy ? ctx.sortBy : 'id') +
                              '&sortdesc='+ ctx.sortDesc +
                              '&offset='+ offset +
                              '&limit='+ ctx.perPage)

      // Must return a promise that resolves to an array of items
      return promise.then((response) => {
        // Pluck the array of items off our axios response
        let items = response.data.items
        _self.totalRows = response.data.total_records

        //console.log("myProvider -> currentPage: "+ ctx.currentPage)
        // Must return an array of items or an empty array if an error occurred
        return(items || [])
      })
      .catch( error => {
            if (error.response) {
                  if (error.response.status = 401) {
                      toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                      this.$router.replace('/login')
                  } 
                  else  {
                      toast.error( error.response.message, "Error")                      
                  }
                } else if (error.request) {
                  console.log(error.request)                      
                  toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('Error', error.message);                      
                }
        })
    },

     async fileUploadEventHandler(event) {
      const notificationId = this.selectedItem.id
      const requestTypeId = this.selectedItem.request_type_id
      const category = "DLT_DOCUMENT"
      const $this = this
      this.showUploadError = false
      
      let file = event.file
      if (!file) return

      // validate if file exceeds 1mb
      if (file.size >= constants.FILE_MAXIMUM_SIZE) {
          this.showUploadError = true
          return
      }

      let formData = new FormData()
      formData.append('file', file, file.name)

      this.showUploadAlert = true
      
      await UploadService.upload(formData, notificationId, requestTypeId, category, event.description).then( (resp) => {
          if (resp.length > 0) {

              this.$store.commit(types.MUTATE_MODIFIED, true)
              this.isUploadReady = true 

              setTimeout(function () {
                  this.showUploadAlert = false
                  this.$refs.fileUpload.reset()
              }.bind(this), 3000)

              // get attachments
              CommonService.fetchDLTAttachment(notificationId).then( (resp) => {
                this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
              })
          }          
      })
    },

    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    sendEmailEventHandler() {
        const $this = this
        let emailTo = this.selectedItem.requested_by_email

        let payload = {
            to: emailTo,
            subject: this.emailSubject,
            message: this.emailMessage
        }

        NotificationService.notify(payload).then( (resp) => {
          toast.success( "The notification email has been sent to "+ emailTo)
        })
    },


    getBadge (status) {
      return status === 'Received' ? 'secondary'
             : status === 'Approved' ? 'success'
             : status === 'Pending' ? 'warning'
             : status === 'Returned' ? 'info'
             : status === 'Cancelled' ? 'danger' : 'primary'
    },
    getAction (action) {
      return action
    },
    getRowCount (items) {
      return items.length
    },
    downloadEventHandler(notificationId, requestTypeId) {
      
      NotificationService.download(notificationId, requestTypeId).then( (resp) => {
          
      })
    },

    itemEventHandler(item) {
        // console.log("**** item ****")
        // console.log(item)
        // console.log(this.$refs.changeStatusModal)
        // console.log(  this.$refs.changeStatusModal.title )

        this.selectedItem = item
        this.selectedStatusId = item.status_id
        this.notes = item.notes
        this.ehoc_ref = item.ehoc_ref
        this.centcom_ref = item.centcom_ref
        this.selectedNV = item.nv_for
        this.nvNumber = item.nv_number
        this.submitted_ehoc = item.submitted_ehoc
        this.selectedEHOCStatusId = item.ehoc_status_id

        this.emailSubject = "Re: Notification #"+ item.id +" "+ this.selectedItem.notification_recipient
        this.emailMessage = null

        CommonService.fetchDLTAttachment(item.id).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
        })


    },
    mofaEventHandler(item) {
       this.$store.commit(types.MUTATE_VIEW_MOFA, true)
       this.$store.commit(types.MUTATE_NOTIFICATION_ID, item.id)
       this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, item.request_type_id)

       const routeName = utils.findMofaNameById( item.request_type_id )

       setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_MOFA, {type: routeName , id:item.id})
        }.bind(this), 600)
       
       // load MOFA form       
       this.$router.replace('/forms/'+ routeName +"-mofa")
    },
    viewEventHandler(notificationId, requestTypeId) {

       this.loadNotification(notificationId) 

       if (requestTypeId === constants.FORM_LAND_MOVEMENT) {
            this.loadLandMovement(notificationId) 
       }
       else if (requestTypeId === constants.FORM_TEMP_VENUE) {
            this.loadTempVenue(notificationId) 
       }
       else if (requestTypeId === constants.FORM_SEA) {
            this.loadSea(notificationId) 
       }
       else if (requestTypeId === constants.FORM_AIR) {
            this.loadAir(notificationId) 
       }
       else if (requestTypeId === constants.FORM_NO_STRIKE_LIST) {
            this.loadNSL(notificationId) 
       }
       else if (requestTypeId === constants.FORM_ADMIN_LETTERS) {
            this.loadAdminLetters(notificationId) 
       }
    },
    copyEventHandler() {
      
       let notificationId = this.selectedItem.id       
       let $this = this
       NotificationService.copyNotificationRequest(notificationId).then( (resp) => {
          toast.success( "Notification #"+ resp.id +" has been created successfully.")
          $this.$refs.table.refresh();
       })

    },
    loadNotification(notificationId) {
       // get notification
       NotificationService.fetchByNotificationId(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_MODE, constants.MODE_EDIT)
          this.$store.commit(types.MUTATE_NOTIFICATION_ID, resp.id)
          this.$store.commit(types.MUTATE_USER_AGENCY_ID, resp.agency_id)
          this.$store.commit(types.MUTATE_PURPOSE_ID, resp.purpose_id)
          this.$store.commit(types.MUTATE_PURPOSE_OTHERS, resp.purpose_others)
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id)
          this.$store.commit(types.MUTATE_MAP, {roadmap: resp.route_map_terrain, satellite: resp.route_map_satellite})          
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id)
          this.$store.commit(types.MUTATE_EHOC_REF, resp.ehoc_ref)
          this.$store.commit(types.MUTATE_CENTCOM_REF, resp.centcom_ref)
          this.$store.commit(types.MUTATE_NV_FOR, resp.nv_for)
          this.$store.commit(types.MUTATE_NV_NUMBER, resp.nv_number)
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id) 
          this.$store.commit(types.MUTATE_REQUESTED_BY, resp.requested_by)
          this.$store.commit(types.MUTATE_LAST_UPDATED_BY, resp.last_updated_by) 
          this.$store.commit(types.MUTATE_NOTES, resp.notes)
          this.$store.commit(types.MUTATE_STATUS_ID, resp.status_id)
          this.$store.commit(types.MUTATE_START_DATE, resp.start_date)
          this.$store.commit(types.MUTATE_REQUESTED_DATE, resp.request_date) 
          
          const orgAnonymous = resp.org_anonymous && resp.org_anonymous.toLowerCase() === "yes";
          this.$store.commit(types.MUTATE_ORG_ANONYMOUS, orgAnonymous)       
          this.$store.commit(types.MUTATE_SUBMITTED_ID, resp.submission_id)          
       }) 
    },
    loadLandMovement(notificationId) {
      
       // get waypoints
       LandMovementService.getWaypoints(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_WAYPOINTS, resp)          
       })

       // get convoys 
       LandMovementService.getConvoys(notificationId).then( (resp) => {    
          this.$store.commit(types.MUTATE_CONVOYS, resp)
       })

       // get participants 
       LandMovementService.getParticipants(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_PARTICIPANTS, resp)
       })

       // get vehicles 
       LandMovementService.getVehicles(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_VEHICLES, resp)
       })

       // get trucks 
       LandMovementService.getTrucks(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_TRUCKS, resp)
       })

       // get photos 
       // LandMovementService.getPhotos(notificationId).then( (resp) => {        
       //    this.$store.commit(types.MUTATE_PHOTOS, resp)
       // })

       // load land movement form
       this.$router.replace('/forms/land-movement')

    },
    loadTempVenue(notificationId) {

       TempVenueService.fetchByNotificationId(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_VENUES, resp)
       })

       // get upload documents 
       CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
       })

        // temp venue
       this.$router.replace('/forms/temp-venue')
    },
    loadSea(notificationId) {

       SeaService.fetchByNotificationId(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_SEA, resp)
       })

      CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
       })

       // sea
       this.$router.replace('/forms/sea-movement')
    },
    loadAir(notificationId) {

        setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_AIR, notificationId)
        }.bind(this), 600)

        // get upload documents 
       CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
       })

       // air
       this.$router.replace('/forms/air-movement')
    },
    loadNSL(notificationId) {

       NSLService.fetchByNotificationId(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_NSL, resp)
       })

       CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
       })

       // air
       this.$router.replace('/forms/no-strike-list')
    },
    loadAdminLetters(notificationId) {

       CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
       })

       // admin letters
       this.$router.replace('/forms/admin-letters')
    },
    submitStatusEventHandler(e) {
        // e.preventDefault()
        const payload = {
            id : this.selectedItem.id,
            status_id : this.selectedStatusId,
            notes : this.notes,
            ehoc_ref: this.ehoc_ref,
            centcom_ref: this.centcom_ref,
            nv_for: this.selectedNV,
            nv_number: this.nvNumber,
            submitted_ehoc: this.submitted_ehoc,
            ehoc_status_id: this.selectedEHOCStatusId,
            last_updated_by: this.$store.state.userId
        }
        this.$store.dispatch(types.ACTION_UPDATE_NOTIFICATION_STATUS, payload)        
        this.$refs.changeStatusModal.hide()
        
        let statusObj = this.$_.find(this.$store.state.statusList, {id: this.selectedStatusId});
        // let ehocStatusObj = this.$_.find(this.$store.state.statusList, {id: this.selectedEHOCStatusId});
        let agencyObj = this.$_.find(this.$store.state.agencyList, {id: this.selectedItem.agency_id});
        let requestTypeObj = this.$_.find(this.$store.state.requestTypeList, {id: this.selectedItem.request_type_id});
        // TEMPORARY NEED TO PUT IT BACK!!!
        let emailTo = this.selectedItem.requested_by_email
        // let emailTo = "jimjaspe@gmail.com"
        let messageBody = "Notification Details:\n\n"+
                          "Notification #: "+ this.selectedItem.id +"\n"+
                          "NV#: "+ this.nvNumber +"\n"+
                          "CENTCOM NV#: "+ this.centcom_ref +"\n"+
                          "Agency: "+ agencyObj.name +"\n"+
                          "Request type: "+ requestTypeObj.description+"\n"+
                          "DLT Status: "+ statusObj.name +"\n"
                          "Recipient: "+ this.selectedItem.notification_recipient
                          // "EHOC Status: "+ ehocStatusObj.name

        // console.log(messageBody)

        let notify = {
            to: emailTo,
            subject: "Notification # "+ this.selectedItem.id +" ("+ this.selectedItem.notification_recipient + ") status changed",
            message: messageBody
        }

        if (this.selectedStatusId === 3 || this.selectedStatusId == 9) {
            NotificationService.notifyWithAttachment(this.selectedItem.id, this.selectedItem.request_type_id, notify).then( (resp) => {
              toast.success( "The notification email has been sent to "+ emailTo)
            })

        }
        else {
            NotificationService.notify(notify).then( (resp) => {
              toast.success( "The notification email has been sent to "+ emailTo)
            })
        }

        setTimeout(function () {
            // this.$store.dispatch(types.ACTION_ADMIN_NOTIFICATION_LIST)
            this.$refs.table.refresh();
            //this.currentPage = 3
            // console.log("currentPage: "+ this.currentPage)
            this.$store.dispatch(types.ACTION_DASHBOARD_STATISTICS, constants.AGENCY_ADMIN)
        }.bind(this), 300)
    },

    statusChangeEventHandler(e) {
      this.selectedStatusId = e
      let statusObj = this.$_.find(this.$store.state.statusList, {id: this.selectedStatusId});

      this.notes = this.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss') + '\n' + statusObj.name
    },

    ehocStatusChangeEventHandler(e) {
      this.selectedEHOCStatusId = e
      let statusObj = this.$_.find(this.$store.state.statusList, {id: this.selectedEHOCStatusId});
      this.notes = this.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss') + '\n' + statusObj.name
    },


    selectNVChangeEventHandler(e) {
      this.selectedNV = e
    },

    nextNVEventHandler() {
       const $this = this
       // console.log(this.selectedNV)
       if ( this.selectedNV == 0 ) {
           toast.error("Please select an option to generate NV# ", "Error")
           return false
       }

       NotificationService.generateNextNVNumber(this.selectedNV).then( (resp) => {
            if (parseInt($this.selectedNV) === 1)
                $this.nvNumber = resp.last_nv_un
            else if (parseInt($this.selectedNV) === 2)  
                $this.nvNumber = 'NG/'+ resp.last_nv_ingo
       })
    },
    nextCentcomNVEventHandler() {
       const $this = this
       this.selectedNV = 3

       NotificationService.generateNextNVNumber(this.selectedNV).then( (resp) => {        
          $this.centcom_ref = resp.centcom
       })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/DLTTable.vue